<div class="repeatable-table">
  <div class="table-responsive">
    <table class="table table-bordered mb-2">
      <thead>
        <tr>
          <th *ngFor="let col of columns">
            {{ col.title }}
            <span *ngIf="!viewOnly && hasMandatory(col)" class="text-danger">*</span>
          </th>
          <th *ngIf="!viewOnly" class="repeatable-table-actions"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let rowGroupCtrl of rows?.controls; let i = index">
          <td *ngFor="let col of rowViews[i]">
            <!-- A cell = the column's fields STACKED. With one field the column header is the
                 label; with several, each field shows its own small label (unless the field's
                 title is blank or just repeats the column header). -->
            <div *ngFor="let field of col.fields" [class.d-none]="field.isHiddenByCurrentVariant" class="mb-2">
              <label *ngIf="showFieldLabel(col, field)" class="repeatable-table-field-label">
                {{ field.title }}<span *ngIf="!viewOnly && field.isMandatory" class="text-danger">*</span>
              </label>
              <app-detail-info-type-container
                *ngIf="!viewOnly; else staticValue"
                [detailInfo]="field"
                [formGroup]="rowGroup(i)"
                [gridView]="true"
                [hideLabel]="true">
              </app-detail-info-type-container>
              <ng-template #staticValue>
                <p class="repeatable-table-static-value">{{ displayFor(field, i) }}</p>
              </ng-template>
              <!-- Completion column: the saved stamp (who / when) beside the tick. It appears after the
                   save that ticked the row, because the server is what records it. -->
              <div *ngIf="isCompletionField(field) && stampFor(i) as stamp" class="text-muted small mt-1">
                {{ stamp.completedDate | date: 'dd/MM/yyyy' }}<ng-container *ngIf="stamp.completedByName">, {{ stamp.completedByName }}</ng-container>
              </div>
            </div>
          </td>
          <td *ngIf="!viewOnly" class="repeatable-table-actions text-center">
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeRow(i)" title="Remove row">
              <i class="bx bx-trash"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!rows?.controls?.length">
          <td [attr.colspan]="columns.length + (viewOnly ? 0 : 1)" class="text-muted small text-center">
            No rows added.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <button *ngIf="!viewOnly" type="button" class="btn btn-sm btn-outline-success" (click)="addRow()">
    <i class="bx bx-plus"></i> {{ addRowLabel }}
  </button>
</div>
